<app-performance>
    <app-data-grid-comp
        [gridId]="gridId"
        [tableId]="db_tables.PerformanceReviewPlans"
        [columns]="columns"
        [filterCategories]="filterCategories"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        category="ReviewPlans"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectableMode: 'multiple',
            selectRowBy: 'id'
        }"
        clickableRows="true"
        [isLoading]="isLoading"
        [clearSelectedItems]="clearSelectedItems"
        searchable="true"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        [rowActionButtons]="gridActionButtons"
        (rowActionEvent)="rowActionEvent($event)"
        (emitGridStateChangeEvent)="gridStateChange($event)"
        (emitOpenDialogEvent)="getReviewPlan($event)"
        (emitDeleteEvent)="deleteReviewPlans($event)"
    ></app-data-grid-comp>
</app-performance>
